import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dOrders$dPayments$dDotpay$dTypes from "../Restaumatic.Orders.Payments.Dotpay.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $Channel = (tag, _1) => ({tag, _1});
const $StartPaymentResult = (tag, _1) => ({tag, _1});
const Form = x => x;
const RedirectURL = value0 => $StartPaymentResult("RedirectURL", value0);
const PaymentForm = value0 => $StartPaymentResult("PaymentForm", value0);
const ApplePayRequestToken = value0 => $StartPaymentResult("ApplePayRequestToken", value0);
const DotpayChannel = value0 => $Channel("DotpayChannel", value0);
const P24Channel = value0 => $Channel("P24Channel", value0);
const StripeChannel = /* #__PURE__ */ $Channel("StripeChannel");
const ChannelInfo = x => x;
const PaymentRequest = x => x;
const newtypePaymentRequest_ = {Coercible0: () => {}};
const newtypeForm_ = {Coercible0: () => {}};
const newtypeChannelInfo_ = {Coercible0: () => {}};
const hasFieldPaymentRequest = dictHasField => dictHasField;
const hasFieldForm = dictHasField => dictHasField;
const hasFieldChannelInfo = dictHasField => dictHasField;
const eqForm = {eq: x => y => x.action === y.action && Data$dEq.eqArrayImpl(x$1 => y$1 => x$1._1 === y$1._1 && x$1._2 === y$1._2)(x.fields)(y.fields)};
const eqStartPaymentResult = {
  eq: x => y => {
    if (x.tag === "RedirectURL") {
      if (y.tag === "RedirectURL") { return x._1.url === y._1.url; }
      return false;
    }
    if (x.tag === "PaymentForm") {
      if (y.tag === "PaymentForm") { return eqForm.eq(x._1.form)(y._1.form); }
      return false;
    }
    if (x.tag === "ApplePayRequestToken") {
      if (y.tag === "ApplePayRequestToken") { return x._1.token === y._1.token; }
      return false;
    }
    return false;
  }
};
const eqChannel = {
  eq: x => y => {
    if (x.tag === "DotpayChannel") {
      if (y.tag === "DotpayChannel") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "P24Channel") {
      if (y.tag === "P24Channel") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "StripeChannel") { return y.tag === "StripeChannel"; }
    return false;
  }
};
const eqChannelInfo = {
  eq: x => y => x.enabled === y.enabled && (() => {
    if (x.id.tag === "DotpayChannel") {
      if (y.id.tag === "DotpayChannel") { return x.id._1 === y.id._1; }
      return false;
    }
    if (x.id.tag === "P24Channel") {
      if (y.id.tag === "P24Channel") { return x.id._1 === y.id._1; }
      return false;
    }
    if (x.id.tag === "StripeChannel") { return y.id.tag === "StripeChannel"; }
    return false;
  })() && (() => {
    if (x.logo.tag === "Nothing") { return y.logo.tag === "Nothing"; }
    if (x.logo.tag === "Just") {
      if (y.logo.tag === "Just") { return x.logo._1 === y.logo._1; }
      return false;
    }
    return false;
  })() && x.name === y.name
};
const eqPaymentRequest = {
  eq: x => y => (() => {
    if (x.applePayToken.tag === "Nothing") { return y.applePayToken.tag === "Nothing"; }
    if (x.applePayToken.tag === "Just") {
      if (y.applePayToken.tag === "Just") { return x.applePayToken._1 === y.applePayToken._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.blikCode.tag === "Nothing") { return y.blikCode.tag === "Nothing"; }
    if (x.blikCode.tag === "Just") {
      if (y.blikCode.tag === "Just") { return x.blikCode._1 === y.blikCode._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.cardToken.tag === "Nothing") { return y.cardToken.tag === "Nothing"; }
    if (x.cardToken.tag === "Just") {
      if (y.cardToken.tag === "Just") { return x.cardToken._1 === y.cardToken._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.channel.tag === "DotpayChannel") {
      if (y.channel.tag === "DotpayChannel") { return x.channel._1 === y.channel._1; }
      return false;
    }
    if (x.channel.tag === "P24Channel") {
      if (y.channel.tag === "P24Channel") { return x.channel._1 === y.channel._1; }
      return false;
    }
    if (x.channel.tag === "StripeChannel") { return y.channel.tag === "StripeChannel"; }
    return false;
  })() && (() => {
    if (x.isIosApp.tag === "Nothing") { return y.isIosApp.tag === "Nothing"; }
    if (x.isIosApp.tag === "Just") {
      if (y.isIosApp.tag === "Just") { return x.isIosApp._1 === y.isIosApp._1; }
      return false;
    }
    return false;
  })()
};
const genericStartPaymentResult = {
  to: x => {
    if (x.tag === "Inl") { return $StartPaymentResult("RedirectURL", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $StartPaymentResult("PaymentForm", x._1._1); }
      if (x._1.tag === "Inr") { return $StartPaymentResult("ApplePayRequestToken", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "RedirectURL") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "PaymentForm") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ApplePayRequestToken") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const genericPaymentRequest = {to: x => x, from: x => x};
const genericForm = {to: x => x, from: x => x};
const showForm = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dTuple$dT2.showT2(Data$dShow.showString)(Data$dShow.showString).show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["action", Data$dShow.showStringImpl(v.action)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "fields",
              $0(v.fields)
            ]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "Form"});
    return x => $0["genericShow'"](x);
  })()
};
const showStartPaymentResult = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["url", Data$dShow.showStringImpl(v.url)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "RedirectURL"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["form", showForm.show(v.form)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "PaymentForm"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["token", Data$dShow.showStringImpl(v.token)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ApplePayRequestToken"});
    return x => {
      const $3 = genericStartPaymentResult.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeForm = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "action"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "fields"
    })({unsafeDecode: Unscramble.decodeArray(Data$dTuple$dT2.udecodeT2(Unscramble.decodeString1)(Unscramble.decodeString1).unsafeDecode)})(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeStartPaymentResult = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "RedirectURL"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "url"})(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "PaymentForm"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "form"})(unscrambleDecodeForm)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ApplePayRequestToken"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "token"})(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericStartPaymentResult.to($0(x));
  })()
};
const genericChannelInfo = {to: x => x, from: x => x};
const genericChannel = {
  to: x => {
    if (x.tag === "Inl") { return $Channel("DotpayChannel", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $Channel("P24Channel", x._1._1); }
      if (x._1.tag === "Inr") { return StripeChannel; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "DotpayChannel") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "P24Channel") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "StripeChannel") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showChannel = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dOrders$dPayments$dDotpay$dTypes.showChannelId.show(v)]})({
      reflectSymbol: () => "DotpayChannel"
    });
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "P24Channel"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "StripeChannel"});
    return x => {
      const $3 = genericChannel.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showChannelInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["enabled", v.enabled ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "id",
            showChannel.show(v.id)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "logo",
            (() => {
              if (v.logo.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.logo._1) + ")"; }
              if (v.logo.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["name", Data$dShow.showStringImpl(v.name)]))([]))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ChannelInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const showPaymentRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "applePayToken",
            (() => {
              if (v.applePayToken.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.applePayToken._1) + ")"; }
              if (v.applePayToken.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "blikCode",
            (() => {
              if (v.blikCode.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.blikCode._1) + ")"; }
              if (v.blikCode.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "cardToken",
            (() => {
              if (v.cardToken.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.cardToken._1) + ")"; }
              if (v.cardToken.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["channel", showChannel.show(v.channel)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "isIosApp",
            (() => {
              if (v.isIosApp.tag === "Just") {
                if (v.isIosApp._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.isIosApp.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([])))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "PaymentRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeChannel = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "DotpayChannel"
    })({unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeInt(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "P24Channel"
    })({unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeInt(x.contents)}))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "StripeChannel"
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericChannel.to($0(x));
  })()
};
const unscrambleDecodeChannelInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "enabled"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "id"
    })(unscrambleDecodeChannel)(Unscramble.decodeRecordCons({reflectSymbol: () => "logo"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "name"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodePaymentRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "applePayToken"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "blikCode"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "cardToken"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "channel"
    })(unscrambleDecodeChannel)(Unscramble.decodeRecordCons({reflectSymbol: () => "isIosApp"})(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeForm = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericForm)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Form"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "fields"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dTuple$dT2.encodeT2({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}).encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "action"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeStartPaymentResult = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericStartPaymentResult)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "RedirectURL"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "url"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PaymentForm"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "form"})({encodeWithOptions: v => encodeForm.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ApplePayRequestToken"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "token"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            return $2.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeChannel = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericChannel)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "DotpayChannel"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dOrders$dPayments$dDotpay$dTypes.encodeChannelId.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "P24Channel"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "StripeChannel"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            return $2.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeChannelInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericChannelInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ChannelInfo"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "name"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "logo"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "id"})({encodeWithOptions: v => encodeChannel.encode}))({reflectSymbol: () => "enabled"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodePaymentRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPaymentRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "PaymentRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "isIosApp"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "channel"})({encodeWithOptions: v => encodeChannel.encode}))({reflectSymbol: () => "cardToken"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "blikCode"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "applePayToken"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeForm = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericForm)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Form"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "fields"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }));
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "action"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeStartPaymentResult = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericStartPaymentResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "RedirectURL"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "url"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PaymentForm"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "form"
  })({decodeWithOptions: v => decodeForm.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ApplePayRequestToken"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "token"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
const decodeChannel = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericChannel)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DotpayChannel"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dOrders$dPayments$dDotpay$dTypes.decodeChannelId.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "P24Channel"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "StripeChannel"})(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))))
};
const decodeChannelInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericChannelInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ChannelInfo"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "name"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "logo"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "id"})({decodeWithOptions: v => decodeChannel.decode})())({reflectSymbol: () => "enabled"})({
    decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodePaymentRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPaymentRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PaymentRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "isIosApp"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "channel"})({
    decodeWithOptions: v => decodeChannel.decode
  })())({reflectSymbol: () => "cardToken"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "blikCode"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "applePayToken"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $Channel,
  $StartPaymentResult,
  ApplePayRequestToken,
  ChannelInfo,
  DotpayChannel,
  Form,
  P24Channel,
  PaymentForm,
  PaymentRequest,
  RedirectURL,
  StripeChannel,
  decodeChannel,
  decodeChannelInfo,
  decodeForm,
  decodePaymentRequest,
  decodeStartPaymentResult,
  encodeChannel,
  encodeChannelInfo,
  encodeForm,
  encodePaymentRequest,
  encodeStartPaymentResult,
  eqChannel,
  eqChannelInfo,
  eqForm,
  eqPaymentRequest,
  eqStartPaymentResult,
  genericChannel,
  genericChannelInfo,
  genericForm,
  genericPaymentRequest,
  genericStartPaymentResult,
  hasFieldChannelInfo,
  hasFieldForm,
  hasFieldPaymentRequest,
  newtypeChannelInfo_,
  newtypeForm_,
  newtypePaymentRequest_,
  showChannel,
  showChannelInfo,
  showForm,
  showPaymentRequest,
  showStartPaymentResult,
  unscrambleDecodeChannel,
  unscrambleDecodeChannelInfo,
  unscrambleDecodeForm,
  unscrambleDecodePaymentRequest,
  unscrambleDecodeStartPaymentResult
};
